module.exports = __webpack_public_path__ + "annualreview2017/static/pdfs/governance-management.ee306e7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pdfs/governance-management.pdf
// module id = 641
// module chunks = 0